import { UPDATE_NAVIGATION } from 'redux/modules/address-suggestion/actions/types';

export const updateNavigation = navigation => ({
  type: UPDATE_NAVIGATION,
  navigation,
});
